import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../../../app/hooks'
import { ButtonCollectionStyled, ButtonGroupStyled, ButtonStyled } from './styled'
import { TradingState, updateTimeInForce } from '../../../../tradingSlice'

interface TimeInForceProperties {
    code: string
}

export const TimeInForceButtons = ({ code }: TimeInForceProperties): React.ReactElement<TimeInForceProperties> => {
    const dispatch = useAppDispatch()
    const _tradingSlice: TradingState = useAppSelector((state) => state.tradingSlice[code])

    const onTimeInForceType = (e: React.MouseEvent<HTMLElement, MouseEvent>, timeInForce: 'DAY' | 'GTC'): void => {
        e?.stopPropagation()
        dispatch(updateTimeInForce({ code: code, timeInForce: timeInForce }))
    }

    return (
        <ButtonCollectionStyled>
            <ButtonGroupStyled>
                <ButtonStyled
                    onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => onTimeInForceType(e, 'DAY')}
                    active={_tradingSlice.order.getValidity() === 'DAY'}
                >
                    DAY
                </ButtonStyled>
                <ButtonStyled
                    onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => onTimeInForceType(e, 'GTC')}
                    active={_tradingSlice.order.getValidity() === 'GTC'}
                >
                    GTC
                </ButtonStyled>
            </ButtonGroupStyled>
        </ButtonCollectionStyled>
    )
}
